import { format, isValid, parseISO } from 'date-fns'

/**
 * Safely format a date string, returning a fallback if invalid
 */
export function formatDate(
  dateStr: string | null | undefined,
  formatStr: string = 'MMM d, yyyy'
): string {
  if (!dateStr) return 'N/A'
  try {
    const date = parseISO(dateStr)
    if (!isValid(date)) {
      // Try parsing as regular date string
      const fallbackDate = new Date(dateStr)
      if (!isValid(fallbackDate)) return 'N/A'
      return format(fallbackDate, formatStr)
    }
    return format(date, formatStr)
  } catch {
    return 'N/A'
  }
}

/**
 * Safely format a date string with time
 */
export function formatDateTime(
  dateStr: string | null | undefined,
  formatStr: string = 'MMM d, yyyy h:mm a'
): string {
  return formatDate(dateStr, formatStr)
}

/**
 * Safely convert to locale string
 */
export function toLocaleString(dateStr: string | null | undefined): string {
  if (!dateStr) return 'N/A'
  try {
    const date = new Date(dateStr)
    if (!isValid(date)) return 'N/A'
    return date.toLocaleString()
  } catch {
    return 'N/A'
  }
}
